import { Component } from '@angular/core'

@Component({
  selector: 'flo-standings-list-view-all-skeleton',
  templateUrl: './standings-list-view-all-skeleton.component.html',
  styleUrls: ['./standings-list-view-all-skeleton.component.scss']
})
export class StandingsListViewAllSkeletonComponent {}
